var _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.309,
    cy: 99.021,
    rx: 0,
    ry: 0,
    fill: "rgba(179, 183, 193, 0.5)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "0;74.078;0",
    keyTimes: "0;0.9;1",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    values: "0;74.078;0",
    keyTimes: "0;0.9;1",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.309,
    cy: 99.021,
    rx: 0,
    ry: 0,
    fill: "rgba(179, 183, 193, 0.5)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "0;74.078;0",
    keyTimes: "0;0.9;1",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "0.8s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "ry",
    values: "0;74.078;0",
    keyTimes: "0;0.9;1",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "0.8s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "0.8s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.94a3cee5fd943463ad4856582611c668.svg";
export { ForwardRef as ReactComponent };